// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"71020c9b","473":"6b3d1e6d","557":"bd5eefd6","741":"5f79e3f8","774":"7ef917c8","782":"e2cbfe8e","803":"f4ddc32b","883":"866d88a3","943":"cb7e992e"}[chunkId] + ".chunk.js";
};